import {
  playoffGameAvailability,
  type PlayoffSeriesState,
} from "../../shared/domain/playoffSeries";

export {
  playoffGameAvailability,
  winsRequired,
} from "../../shared/domain/playoffSeries";

export function playoffAvailabilityLabel(
  series: PlayoffSeriesState,
  gameNumber: number,
): string | null {
  const availability = playoffGameAvailability(series, gameNumber);
  if (availability === "not_needed") return "NOT NEEDED";
  if (availability === "if_necessary") return "IF NECESSARY";
  if (
    gameNumber === series.ourWins + series.opponentWins + 1 &&
    series.ourWins === series.opponentWins &&
    gameNumber === series.bestOf
  ) {
    return "DECIDING GAME";
  }
  return null;
}
